import { gql } from '@apollo/client';

export default gql`
  mutation addPreferencesBusinessType($input: BusinessTypeInput!) {
    addBuyerPreferencesBusinessType(input: $input)
  }
`;
